import { css } from '@emotion/react';
import { DevicesQueries } from '@frontend/api-devices';
import { useTranslation } from '@frontend/i18n';
import { usePhoneSettingsShallowStore } from '@frontend/phone-config';
import { SurfaceHeader } from '@frontend/surface-header';
import { theme } from '@frontend/theme';
import { ModalControlModalProps, Table, TextLink, Tray } from '@frontend/design-system';

type Props = ModalControlModalProps & {
  deviceIds: string[];
  e911Name: string;
  openEdit: () => void;
};
export const DeviceAssignmentsToE911 = ({ deviceIds, e911Name, openEdit, ...modalProps }: Props) => {
  const { settingsTenantLocation } = usePhoneSettingsShallowStore('settingsTenantLocation');
  const { t } = useTranslation('phone', { keyPrefix: 'e911' });

  const { data: { devices } = { devices: [] } } = DevicesQueries.useGetDevicesList({
    tenantId: settingsTenantLocation?.phoneTenantId,
  });

  const mappedDevices = devices.filter((device) => deviceIds.includes(device.deviceId));

  const openEditDeviceAssignments = () => {
    modalProps.onClose();
    openEdit();
  };
  return (
    <Tray {...modalProps} width='medium'>
      <SurfaceHeader.Root noBorder css={{ margin: theme.spacing(-4, -4, 0, -4), width: 'calc(100% + 64px)' }}>
        <SurfaceHeader.Row>
          <SurfaceHeader.Title>{t('Devices Using {{name}}', { name: e911Name })}</SurfaceHeader.Title>
          <SurfaceHeader.Actions>
            <SurfaceHeader.Icon iconName='x' onClick={modalProps.onClose} />
          </SurfaceHeader.Actions>
        </SurfaceHeader.Row>
        <SurfaceHeader.Body>{t('{{count}} Devices', { count: deviceIds.length })}</SurfaceHeader.Body>
      </SurfaceHeader.Root>
      <Tray.Body>
        <TextLink
          weight='bold'
          css={css`
            margin-left: ${theme.spacing(0.75)};
            margin-bottom: ${theme.spacing(2)};
          `}
          onClick={openEditDeviceAssignments}
        >
          {t('Assign Devices', { count: devices?.length })}
        </TextLink>

        <Table
          data={mappedDevices}
          isPaginated
          colConfig={[
            {
              Header: t('Device Name'),
              id: 'contact-list-name',
              accessor: (device) => device.name,
            },
          ]}
        />
      </Tray.Body>
    </Tray>
  );
};
